import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { moneyFormat } from "../../util/format";

export const OrderSuccess = () => {
  const location = useLocation();
  const orderData = location.state?.orderData || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container-fluid py-5">
      <div className="row px-xl-5 justify-content-center">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-5">
              <div className="text-center mb-5">
                <div className="mb-4">
                  <i
                    className="fas fa-check-circle text-success"
                    style={{ fontSize: "5rem" }}
                  ></i>
                </div>
                <h2 className="font-weight-bold text-uppercase mb-3">
                  Đặt hàng thành công
                </h2>
                <p className="text-muted mb-0">
                  Cảm ơn quý khách đã mua sắm tại cửa hàng chúng tôi
                </p>
                {orderData.orderCode && (
                  <p className="mt-2">
                    Mã đơn hàng:{" "}
                    <span className="font-weight-bold">
                      {orderData.orderCode}
                    </span>
                  </p>
                )}
              </div>

              <div className="row mb-4">
                <div className="col-md-6 mb-4 mb-md-0">
                  <div className="card h-100 border-0 bg-light">
                    <div className="card-body">
                      <h5 className="font-weight-bold mb-3">
                        Thông tin đơn hàng
                      </h5>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Ngày đặt hàng:</span>
                        <span>{new Date().toLocaleDateString("vi-VN")}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          Phương thức thanh toán:
                        </span>
                        <span>
                          {orderData.paymentMethod === "cod"
                            ? "Thanh toán khi nhận hàng"
                            : orderData.paymentMethod === "banktransfer"
                              ? "Chuyển khoản ngân hàng"
                              : "Thanh toán trực tuyến"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">
                          Phương thức vận chuyển:
                        </span>
                        <span>
                          {orderData.shippingMethod === "standard_shipping"
                            ? "Giao hàng tiêu chuẩn"
                            : "Giao hàng nhanh"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light">
                    <div className="card-body">
                      <h5 className="font-weight-bold mb-3">
                        Thông tin giao hàng
                      </h5>
                      <p className="mb-1">
                        <span className="font-weight-medium">Người nhận:</span>{" "}
                        {orderData.customerName || ""}
                      </p>
                      <p className="mb-1">
                        <span className="font-weight-medium">
                          Số điện thoại:
                        </span>{" "}
                        {orderData.customerPhone || ""}
                      </p>
                      <p className="mb-1">
                        <span className="font-weight-medium">Email:</span>{" "}
                        {orderData.customerEmail || ""}
                      </p>
                      <p className="mb-0">
                        <span className="font-weight-medium">Địa chỉ:</span>{" "}
                        {orderData.customerAddress || ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {orderData.items && orderData.items.length > 0 && (
                <div className="card border-0 bg-light mb-4">
                  <div className="card-body p-4">
                    <h5 className="font-weight-bold mb-3">Chi tiết đơn hàng</h5>
                    <div className="table-responsive">
                      <table className="table table-borderless mb-0">
                        <thead className="bg-secondary text-dark">
                          <tr>
                            <th>Sản phẩm</th>
                            <th className="text-center">Số lượng</th>
                            <th className="text-right">Giá</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.items.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.name}
                                {item.options &&
                                  item.options.length > 0 &&
                                  item.options.map((opt, i) => (
                                    <span key={i}>
                                      {" - "}
                                      {opt.value}
                                    </span>
                                  ))}
                              </td>
                              <td className="text-center">{item.quantity}</td>
                              <td className="text-right">
                                {moneyFormat(item.price * item.quantity)}
                              </td>
                            </tr>
                          ))}
                          <tr className="border-top">
                            <td
                              colSpan="2"
                              className="text-right font-weight-bold"
                            >
                              Tạm tính:
                            </td>
                            <td className="text-right">
                              {moneyFormat(orderData.subtotal || 0)}
                            </td>
                          </tr>
                          {/* <tr>
                            <td colSpan="2" className="text-right font-weight-bold">Phí vận chuyển:</td>
                            <td className="text-right">{moneyFormat(orderData.shipping || 20000)}</td>
                          </tr> */}

                          {orderData.discountAmount > 0 && (
                            <tr>
                              <td
                                colSpan="2"
                                className="text-right font-weight-bold"
                              >
                                Giảm giá:
                              </td>
                              <td className="text-right">
                                -{moneyFormat(orderData.discountAmount)}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td
                              colSpan="2"
                              className="text-right font-weight-bold"
                            >
                              Tổng cộng:
                            </td>
                            <td className="text-right font-weight-bold">
                              {moneyFormat(orderData.total || 0)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              <div className="text-center mt-4">
                <div className="row justify-content-center">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <Link
                      to="/"
                      className="btn btn-outline-primary btn-block py-3"
                    >
                      <i className="fas fa-home mr-2"></i>Tiếp tục mua sắm
                    </Link>
                  </div>
                  {/* <div className="col-md-6">
                    <Link
                      to="/account/orders"
                      className="btn btn-primary btn-block py-3"
                    >
                      <i className="fas fa-clipboard-list mr-2"></i>Xem đơn hàng
                      của tôi
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
